import React, { useEffect } from "react";
import "./Dashboard.css";
import DashBoardSmallCard from "../../components/dashBoard_smallcard/DashBoardSmallCard";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { Allblogs } from "../../actions/BlogAction";
import { AllcaseStudys } from "../../actions/caseStudyAction";
import { getQueryData } from "../../actions/querieAuction";

const DashBoard = () => {
  const blogData = [
    { month: "January", count: 10 },
    { month: "February", count: 15 },
    { month: "March", count: 20 },
    // Add more objects for other months as needed
  ];
  const dispatch = useDispatch()
  const { allBlog } = useSelector((state) => state.blog)
  const { allcaseStudy } = useSelector((state) => state.caseStudyState)
  const { queries } = useSelector((state) => state.querieState);


  useEffect(() => {
    dispatch(Allblogs)
    dispatch(AllcaseStudys)
    dispatch(getQueryData)
  }, [dispatch])


  return (
    <div className="dashboard">
      <div className="dashboard_top">
        <DashBoardSmallCard allCount={allBlog?.length} name={"Blogs"} />
        <DashBoardSmallCard allCount={allcaseStudy?.length} name={"Case Studies"} />
        <DashBoardSmallCard allCount={queries?.length} name={"Queries"} />
      </div>
      <LineChart width={600} height={300} data={blogData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="count" stroke="#8884d8" />
      </LineChart>
    </div>
  );
};

export default DashBoard;
